module.exports = __webpack_public_path__ + "img/pay-card.d4755465.png";